module.exports = __webpack_public_path__ + "static/media/icon-credit.2b2bf844.svg";